__turbopack_context__.v({
  "Cont": "Related-module-sass-module__IwRtsG__Cont",
  "Projects": "Related-module-sass-module__IwRtsG__Projects",
  "Related": "Related-module-sass-module__IwRtsG__Related",
});
